import React from "react";
import "./terms.css";

const Terms = () => {
  return (
    <React.Fragment>
      <div className="WordSection1">
        <p>
          <b>
            <span  >
              PRIVACY STATEMENT
            </span>
          </b>
        </p>
       
        
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <span  >
            This Privacy Statement applies to Syngenta South Africa, Syngenta Zambia
            Ltd. and the entities we own or control (“<b>Syngenta</b>,” “<b>we</b>,”
            “<b>us</b>” or “<b>our</b>”). Your privacy is important to us. Syngenta
            has therefore developed this privacy policy (this “Statement” or
            “Privacy Statement”) to inform you how Syngenta collects, stores, uses
            and processes the personal data and information you provide us through
            this website.
          </span>
        </p>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <b>
            <span  >
              Effective date
            </span>
          </b>
          <span  >
            .&nbsp;1 September 2025&nbsp;
          </span>
        </p>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <b>
            <span  >
              Scope of this Statement
            </span>
          </b>
          <span  >
            .&nbsp;This Statement covers the personal data and information
            (hereinafter “Personal Information”) we collect through these sites.{" "}
          </span>
        </p>
        
        <ul  >
          <li
            
            style={{ color: "#215E99",  textAlign: "justify" }}
          >
            <span  style={{ color: "windowtext" }}>
              <a href="https://www.syngenta.co.za/">
                <span
                  style={{
                    color: "#215E99",
                    textDecoration: "none"
                  }}
                >
                  https://www.syngenta.co.za/
                </span>
              </a>
            </span>
          </li>
        </ul>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <b>
            <span  >
              Cropwise Services and Additional Privacy Policy
            </span>
          </b>
        </p>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <span  >
            When you initially express interest in Cropwise services through this
            website, Syngenta’s relevant legal entity in the respective region acts
            as the responsible party for your personal information under this
            Privacy Statement. However, when you decide to become a subscriber and
            actively sign up for Cropwise services, you will be required to accept
            an additional, separate privacy policy that governs the Cropwise
            platform.
          </span>
        </p>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <span  >
            Lead Stage: While you are exploring Cropwise services or expressing
            initial interest, your personal information is processed by Syngenta’s
            relevant legal entity in the respective region under this Privacy
            Statement.
          </span>
        </p>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <span  >
            Subscriber Stage: Upon subscribing to Cropwise services, you will be
            presented with and must accept the Cropwise Privacy Policy, which
            becomes the governing document for your use of the Cropwise platform
          </span>
        </p>
        
        <ul  >
          <li
            
            style={{ color: "#215E99",  textAlign: "justify" }}
          >
            <span  style={{ color: "windowtext" }}>
              <a href="https://operations.cropwise.com/legal/privacy-policy.html">
                <span
                  style={{
                    color: "#215E99",
                    textDecoration: "none"
                  }}
                >
                  https://operations.cropwise.com/legal/privacy-policy.html
                </span>
              </a>
            </span>
          </li>
        </ul>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <span  >
            Personal Information is data that identifies you personally, either
            alone or in combination with other information available to us. Examples
            of Personal Information include your name, address, email address, tax
            identification number, if applicable, and the information you provide
            when you use our site to create an account or a personal profile.
          </span>
        </p>
       
        <p
          
          style={{  textAlign: "justify" }}
        >
          <span  >
            Personal Information is requested when you order a service, register for
            an account and send us feedback. For example, this information might
            include your name, address (both billing and registered), email address,
            industry and product details, and credit card or other payment
            information. Such information may be held on our contacts and
            administration databases either because of the work we have done with
            you or are currently engaged in, or because we believe you might be
            interested in receiving material from us about our business, products,
            programs and services. This allows us to manage our relationship with
            you efficiently, improve our site and the services which we offer to you
            and to target items of interest we may send to you.
          </span>
        </p>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <span  >
            Non-personally identifiable information refers to information that is
            statistical and/or anonymized in nature only and that does not, by
            itself, allow to identify a specific individual or entity, and which
            depends upon the visiting you do on the site. For example, this
            information may include the domain from which you access the internet,
            the date and time you access the site, and the internet address of the
            website from which you linked directly to the site. This information is
            used in an aggregate form to make the site more useful and attractive to
            its users.
          </span>
        </p>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <b>
            <span  >
              What Personal Information does Syngenta collect?
            </span>
          </b>
        </p>
        
        <ul  >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              Name
            </span>
          </li>
        </ul>
        
        <ul  >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              Email
            </span>
          </li>
        </ul>
        
        <ul  >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              Phone
            </span>
          </li>
        </ul>
        
        <ul  >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              Business/Trading Name
            </span>
          </li>
        </ul>
        
        <ul  >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              Location
            </span>
          </li>
        </ul>
        
        <ul  >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              Crop Interest
            </span>
          </li>
        </ul>
        
        <ul  >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              Legal entity Trading name
            </span>
          </li>
        </ul>
        
        <ul  >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              Where did you hear from Cropwise
            </span>
          </li>
        </ul>
        
        <ul  >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              Farm name
            </span>
          </li>
        </ul>
        
        <ul  >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              Province
            </span>
          </li>
        </ul>
        
        <ul  >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              City
            </span>
          </li>
        </ul>
        
        <ul  >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              District
            </span>
          </li>
        </ul>
        
        <ul  >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              Country
            </span>
          </li>
        </ul>
        
        <ul  >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              Type of legal entity
            </span>
          </li>
        </ul>
        
        <ul  >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              Postal Code
            </span>
          </li>
        </ul>
        
        <ul  >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              Tax number / Vat Number
            </span>
          </li>
        </ul>
        
        <ul  >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              Current Farming practices
            </span>
          </li>
        </ul>
        
        <ul  >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              Business Registration number
            </span>
          </li>
        </ul>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <b>
            <span  >
              How does Syngenta use your Personal Information?
            </span>
          </b>
        </p>
       
        <p
          
          style={{  textAlign: "justify" }}
        >
          <span  >
            We use the Personal Information we collect through our site:
          </span>
        </p>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <b>
            <span  >
              To fulfil our contract with you.
            </span>
          </b>
        </p>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <span  >
            With Your Explicit Consent we will use your personal information to:
          </span>
        </p>
        
        <ul  >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              Provide products, information, and services you request from us
            </span>
          </li>
        </ul>
        
        <ul  >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              Deliver goods or services to you
            </span>
          </li>
        </ul>
        
        <ul  >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              Bill you for the use of our products or services
            </span>
          </li>
        </ul>
        
        <ul  >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              Manage your account and registration as a service user
            </span>
          </li>
        </ul>
        
        <ul  >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              Execute the purchase contract for products, items, or services
            </span>
          </li>
        </ul>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <span  >
            We will obtain your specific consent before using your information to:
          </span>
        </p>
        
        <ul  >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              Send you marketing communications about:
            </span>
          </li>
        </ul>
        
        <ul  >
          <ul  >
            <li
              
              style={{  textAlign: "justify" }}
            >
              <span
                
                
              >
                Cropwise platform features and improvements
              </span>
            </li>
          </ul>
        </ul>
        
        <ul  >
          <ul  >
            <li
              
              style={{  textAlign: "justify" }}
            >
              <span
                
                
              >
                Spray assist services and updates
              </span>
            </li>
          </ul>
        </ul>
        
        <ul  >
          <ul  >
            <li
              
              style={{  textAlign: "justify" }}
            >
              <span
                
                
              >
                Related Cropwise products and services
              </span>
            </li>
          </ul>
        </ul>
        
        <ul  >
          <ul  >
            <li
              
              style={{  textAlign: "justify" }}
            >
              <span
                
                
              >
                Syngenta agricultural products
              </span>
            </li>
          </ul>
        </ul>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <span  >
            You may withdraw your consent at any time by contacting{" "}
          </span>
          <span >
            <a href="mailto:InformationOfficer@syngenta.co.za">
              <span >
                InformationOfficer@syngenta.co.za
              </span>
            </a>
          </span>
        </p>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <b>
            <span  >
              For Our Legitimate Interests
            </span>
          </b>
        </p>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <span  >
            Where necessary and without overriding your rights, we process your
            information to:
          </span>
        </p>
        
        <ul  >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              Provide effective customer service
            </span>
          </li>
        </ul>
        
        <ul  >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              Enhance our products and services
            </span>
          </li>
        </ul>
        
        <ul  >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              Conduct analytics on user data, behaviour, and profiles (in anonymized
              or aggregated form where possible)
            </span>
          </li>
        </ul>
        
        <ul  >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              Store your information in our CRM database for efficient service
              delivery
            </span>
          </li>
        </ul>
        
        <ul  >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              Conduct research and statistical analysis
            </span>
          </li>
        </ul>
        
        <ul  >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              Monitor website usage to improve our services
            </span>
          </li>
        </ul>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <b>
            <span  >
              To Comply with Legal Obligations
            </span>
          </b>
        </p>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <span  >
            We process your information when necessary to:
          </span>
        </p>
        
        <ul  >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              Meet security, credit, or fraud prevention requirements
            </span>
          </li>
        </ul>
        
        <ul  >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              Comply with applicable laws and regulations
            </span>
          </li>
        </ul>
        
        <ul  >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              Respond to requests from competent authorities
            </span>
          </li>
        </ul>
        
        <ul  >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              Maintain records as required by POPIA and other applicable laws
            </span>
          </li>
        </ul>
        
        <ul  >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              Protect our rights and/or property
            </span>
          </li>
        </ul>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <b>
            <span  >
              Additional Information Processing
            </span>
          </b>
        </p>
        
        <ul  >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              We may contact you via email, phone calls, SMS, or other electronic
              communications regarding updates or information related to your
              services, including necessary security updates
            </span>
          </li>
        </ul>
        
        <ul  >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              Any use of your personal information for purposes not listed above
              will only occur with your additional consent or as permitted by law
            </span>
          </li>
        </ul>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <span  >
            All personal information processing activities are conducted in
            accordance with the principles of minimality, purpose specification, and
            further processing limitation as required by POPIA.
          </span>
        </p>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <b>
            <span  >
              How does Syngenta disclose my Personal Information?
            </span>
          </b>
        </p>
       
        <p
          
          style={{  textAlign: "justify" }}
        >
          <u>
            <span  >
              Service providers.
            </span>
          </u>
          <span  >
            &nbsp;We disclose Personal Information to companies and organizations
            that perform services on our behalf, for example, companies that provide
            support services to us (such as credit card processing services, data
            storage services, and web hosting services) or that help us market our
            products and services (such as third-party e-mail marketing companies).
            These third parties are required by contract, through a third-party
            operator agreement, to use the Personal Information we disclose to them
            only to perform services on our behalf and to take commercially
            reasonable measures to protect the confidentiality and security of your
            Personal Information. to use the Personal Information we disclose to
            them only to perform services on our behalf and to take commercially
            reasonable measures to protect the confidentiality and security of your
            Personal Information.
          </span>
        </p>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <u>
            <span  >
              Within Syngenta
            </span>
          </u>
          <span  >
            .&nbsp;We may disclose the Personal Information we collect through our
            Site within Syngenta or with other affiliates of Syngenta for
            cross-marketing and other purposes.
          </span>
        </p>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <u>
            <span  >
              Business transfers
            </span>
          </u>
          <span  >
            .&nbsp;Your Personal Information may be transferred to a company that
            has acquired the stock or assets of Syngenta, one of its affiliates, or
            one of our businesses, for example, as the result of a sale, merger,
            reorganization or liquidation. If such a transfer occurs, the acquiring
            company's use of your Personal Information will still be subject to this
            policy and the privacy preferences you have expressed to us.
          </span>
        </p>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <u>
            <span  >
              As described in a privacy notice
            </span>
          </u>
          <span  >
            .&nbsp;We reserve the right to disclose your Personal Information as
            described in any additional privacy notice posted on the web page (or
            area) where you provide that information. By providing your Personal
            Information on that web page you will be consenting to the disclosure of
            your Personal Information as described in that privacy notice.
          </span>
        </p>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <b>
            <span  >
              How can you exercise your rights in relation to your Personal
              Information?
            </span>
          </b>
        </p>
       
        <p
          
          style={{  textAlign: "justify" }}
        >
          <span  >
            We strive to maintain a high level of transparency about the data we
            process. As regards our processing of your Personal Information
            described in this Statement, you have the following rights:
          </span>
        </p>
        
        <ul  >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              To confirm Syngenta is processing your Personal Information, to get
              access to or receive a copy of the Personal Information we may have
              about you;
            </span>
          </li>
        </ul>
        
        <ul  >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              To require us to rectify or update any inaccurate Personal
              Information, or complete any incomplete Personal Information;
            </span>
          </li>
        </ul>
        
        <ul  >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              To require us to delete or erase your Personal Information;
            </span>
          </li>
        </ul>
        
        <ul  >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              To restrict our processing of your Personal Information;
            </span>
          </li>
        </ul>
        
        <ul  >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              To require that we stop processing your Personal Information for
              direct marketing purposes. Subject to other legitimate interests which
              we may be able to rely on (e.g. in the context of legal claims pending
              or threatened against us), we will then no longer be allowed to
              process your Personal Information
            </span>
          </li>
        </ul>
      
        <p  style={{ marginLeft: ".25in" }}>
          <span >
            If you are accessing Cropwise from Zambia, you also have the following
            rights:{" "}
          </span>
        </p>
        <ul  >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              To request data portability, allowing you to obtain and reuse your
              personal information for your own purposes across different services
            </span>
          </li>
        </ul>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <span  >
            If you wish to exercise any of your above rights, you can contact us by
            sending an email to the Information Officer – see the contact details on
            this page. @
          </span>
          <span >
            <a href="mailto:InformationOfficer@syngenta.co.za%20">
              <span >
                InformationOfficer@syngenta.co.za{" "}
              </span>
            </a>
          </span>
        </p>
       
        <p
          
          style={{  textAlign: "justify" }}
        >
          <span  >
            We will respond to your reasonably specified request as quickly as
            possible after validating the request.
          </span>
        </p>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <span  >
            We will without undue delay modify your Personal Information if we agree
            that it is either inaccurate, out of date, incomplete, irrelevant or
            misleading, after considering the purposes for which it was collected.
            If we correct it and had previously disclosed it to a third party, we
            will also notify that third party if required to by law.
          </span>
        </p>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <span  >
            If we disagree with your request to correct your Personal Information,
            we will explain the reason for refusal and the ways you can complain.
          </span>
        </p>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <b>
            <span  >
              How long does Syngenta store your Personal Information?
            </span>
          </b>
        </p>
       
        <p
          
          style={{  textAlign: "justify" }}
        >
          <span  >
            We are committed to keeping your Personal Information accurate,
            up-to-date, and retained only as long as necessary. Our retention
            practices follow these principles:
          </span>
        </p>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <span  >
            We retain your Personal Information only for the time required to fulfil
            the specific purposes for which it was collected, including providing
            our services, complying with legal requirements, resolving disputes, and
            enforcing our agreements.
          </span>
        </p>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <span  >
            Retention periods vary according to the type of information and its
            purpose. There is no standard retention period, as different categories
            of data have different requirements based on their purpose and relevant
            regulations.
          </span>
        </p>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <span  >
            In some cases, we may need to retain your Personal Information beyond
            the original purpose's requirements (for example, for pending legal
            claims or regulatory compliance). In these instances, we will no longer
            actively process this information for the original purpose.
          </span>
        </p>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <span  >
            When your Personal Information is no longer necessary for any legitimate
            purpose, or when you withdraw consent and no other legal basis for
            processing exists, we will securely dispose of or anonymize it.
          </span>
        </p>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <span  >
            Should you wish to obtain more specific information about where and how
            long your Personal Information is stored, or about exercising your right
            to erasure, please contact our Information Officer at{" "}
          </span>
          <span >
            <a href="mailto:InformationOfficer@syngenta.co.za">
              <span >
                InformationOfficer@syngenta.co.za
              </span>
            </a>
          </span>
          <span  >
            .
          </span>
        </p>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <b>
            <span  >
              How does Syngenta protect Personal Information?
            </span>
          </b>
        </p>
       
        <p
          
          style={{  textAlign: "justify" }}
        >
          <span  >
            We have reasonable commercial technology and operational security
            standards in place to protect all personal information provided by
            individuals from loss, misuse, and unauthorized access, disclosure,
            alteration, or destruction. Personal information is only accessible to
            authorized Syngenta personnel who are aware of our privacy obligations.
          </span>
        </p>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <span  >
            There is a data breach notification system in place, and you will be
            notified if your data is disclosed to unauthorized parties.
          </span>
        </p>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <span  >
            In line with cyber security law, Syngenta also applies measures to
            safeguard the integrity of its systems and prevent unauthorized access,
            interception, or misuse of data.
          </span>
        </p>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <b>
            <span  >
              Links to other Syngenta websites
            </span>
          </b>
        </p>
       
        <p
          
          style={{  textAlign: "justify" }}
        >
          <span  >
            This Site may contain hyperlinks to other websites operated by Syngenta
            or other Syngenta entities ("Other Syngenta Website(s)"). These Other
            Syngenta Websites are separate and distinct websites. Each serves a
            different purpose. Each Other Syngenta Website is therefore governed by
            its own terms of use and its own privacy statement. If you access Other
            Syngenta Websites through links on this site, please take a few minutes
            to review the terms of use and privacy statement posted on each Other
            Syngenta Website you visit.
          </span>
        </p>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <b>
            <span  >
              Links to other web sites
            </span>
          </b>
        </p>
       
        <p
          
          style={{  textAlign: "justify" }}
        >
          <span  >
            This site may contain links to web sites operated by other companies,
            including websites operated by our third-party service providers, our
            affiliates, and other third parties. This Statement does not apply to
            Personal Information collected on any of these third-party web sites.
            When you access third-party web sites through a link on this site,
            please take a few minutes to review the privacy policy posted on that
            site.
          </span>
        </p>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <b>
            <span  >
              Children
            </span>
          </b>
        </p>
       
        <p
          
          style={{  textAlign: "justify" }}
        >
          <span  >
            Our Site is not directed nor targeted to children under the age of 18.
            We do not use our Site to knowingly solicit Personal Information from,
            or market to, children under the age of 18. If you are under the age of
            18, do not provide us with any Personal Information. If we learn that
            someone under 18 has provided Personal Information through one of our
            sites, we will use reasonable efforts to remove such Personal
            Information from our databases.
          </span>
        </p>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <b>
            <span  >
              Special notice for visitors who reside outside the South Africa
            </span>
          </b>
        </p>
       
        <p
          
          style={{  textAlign: "justify" }}
        >
          <span  >
            Syngenta uses web servers and stores data in global{" "}
            <b>servers worldwide</b>. We may transfer your Personal Information to
            our service providers for the purposes described in this Statement.
            Different countries have different privacy laws and requirements, and
            some provide less legal protection for your personal information than
            others.
          </span>
        </p>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <span  >
            Please know, however, that no matter where your Personal Information is
            collected or processed, if it was collected through this Site, we will
            ensure that it is protected by the terms of this Statement and any
            privacy notices or click-through agreements that apply to you.
          </span>
        </p>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <span  >
            By using this site, you are consenting to the collection, use, and
            transfer of your Personal Information in or to the South Africa or any
            other country in the world.
          </span>
        </p>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <b>
            <span  >
              Governing law &amp; Jurisdiction
            </span>
          </b>
        </p>
       
        <p
          
          style={{  textAlign: "justify" }}
        >
          <span  >
            1. This Statement is governed under the laws the Protection of Personal
            Information Act 04 of 2013 (POPIA).
          </span>
        </p>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <span  >
            2. Processing personal information in accordance with the eight POPIA
            processing criteria.
          </span>
        </p>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <span  >
            3. Follow good practice; and Privacy by design.
          </span>
        </p>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <span  >
            4. Protect Syngenta from the consequences of a breach of its legislative
            responsibilities.
          </span>
        </p>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <span  >
            Syngenta is a privacy-conscious company that is dedicated to protecting
            your privacy and managing your information openly and transparently.
            This Privacy policy explains what information we collect about you, as
            well as how we use and share that information. This Privacy Statement
            also outlines your data privacy rights and who you can contact for more
            information or questions.
          </span>
        </p>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <b>
            <span  >
              Questions, concerns and complaints concerning our privacy practices
            </span>
          </b>
        </p>
       
        <p
          
          style={{  textAlign: "justify" }}
        >
          <span  >
            Should you have any question or concern on how Syngenta utilizes your
            Personal Information, you can contact our Information Officer – see the
            contact details on this page.
            <br />
            You also have a right to lodge a complaint with the Information
            Regulator
          </span>
        </p>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <b>
            <span  >
              Requests:
            </span>
          </b>
        </p>
       
        <p
          
          style={{  textAlign: "justify" }}
        >
          <span  >
            To exercise your privacy rights:
          </span>
        </p>
        
        <ol  start={1} >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              To know what personal information is collected about you through this
              site;
            </span>
          </li>
        </ol>
        
        <ol  start={2} >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              To access any personal information collected about you;
            </span>
          </li>
        </ol>
        
        <ol  start={3} >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              To opt out of the sale of your personal information;
            </span>
          </li>
        </ol>
        
        <ol  start={4} >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              The return of any personal information collected about you through
              this site;
            </span>
          </li>
        </ol>
        
        <ol  start={5} >
          <li
            
            style={{  textAlign: "justify" }}
          >
            <span  >
              The deletion of any personal information collected about you through
              this site.
            </span>
          </li>
        </ol>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <span  >
            Contact the Information Office{" "}
          </span>
          <span >
            <a href="mailto:InformationOfficer@syngenta.com">
              <span >
                InformationOfficer@syngenta.com
              </span>
            </a>
          </span>
        </p>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <b>
            <span  >
              Changes
            </span>
          </b>
        </p>
        
        <p
          
          style={{  textAlign: "justify" }}
        >
          <span  >
            Syngenta reserves the right to amend this Statement, including the
            Notice, at our discretion and at any time.
          </span>
        </p>
       
      </div>
      
      
    </React.Fragment>

  );
};

export default Terms;